import { MOCK_GROUP_ID } from './mockSite';
/**
 * Dataset mock dei Team di sito (com.liferay.portal.kernel.model.Team), esposti
 * dagli handler MSW /teams/{groupId} e /team/{teamId}. Ogni team appartiene a un
 * sito (groupId) e referenzia i suoi membri per userId: l'handler risolve i
 * MemberDto contro MOCK_USERS (single source of truth degli utenti mock), così i
 * membri restano coerenti con la lista utenti del pannello.
 */

/** Team mock: i membri sono referenziati per userId (risolti contro MOCK_USERS). */
export interface MockTeam {
  teamId: number;
  groupId: number;
  name: string;
  description: string;
  memberIds: number[];
}

export const mockTeams: MockTeam[] = [
  {
    teamId: 9001,
    groupId: MOCK_GROUP_ID,
    name: 'Commerciale',
    description: 'Team vendite e gestione trattative',
    memberIds: [1, 2],
  },
  {
    teamId: 9002,
    groupId: MOCK_GROUP_ID,
    name: 'Supporto tecnico',
    description: 'Assistenza tecnica e installazioni',
    memberIds: [3, 4],
  },
  {
    teamId: 9003,
    groupId: MOCK_GROUP_ID,
    name: 'Direzione',
    description: 'Coordinamento e amministrazione',
    memberIds: [1],
  },
];

/** Contatore per i nuovi team creati dagli handler di test. */
let nextTeamId = 9100;
export const consumeNextTeamId = (): number => nextTeamId++;
